<template>
  <WebhookForm :id="id" :initial="effectiveInitial" :visibility-config="visibilityConfig" @saved="$emit('saved')">
  </WebhookForm>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'

export default defineComponent({
  name: 'LosantForm',
  components: { WebhookForm },
  props: {
    id: String,
    initial: Object as PropType<Record<string, unknown>>
  },
  emits: ['saved'],
  setup(props) {
    const defaultInitial = {
      name: '',
      event: 'losant-data',
      template: 'losant',
      url: 'https://triggers.losant.com/webhooks/WEBHOOK_ID',
      requestType: 'POST',
      noDefaults: false,
      rejectUnauthorized: true,
      unchunked: false,
      data_url_response_event: false,
      json: {}
    } as Record<string, unknown>

    const effectiveInitial = computed<Record<string, unknown>>(() => {
      return (props.initial as any) || defaultInitial
    })
    
    const visibilityConfig = {
      jsonTab: false,
      secrets: false,
      requestURL: true,
      requestType: false,
      requestFormat: false,
      queryParams: false,
      httpHeaders: false,
      httpBasicAuth: false,
      responseTemplate: false
    }
    
    return { effectiveInitial, visibilityConfig }
  }
})
</script>
